var Pluswerk = {};
var $html = $('html');
var $body = $('body');

Pluswerk.PlusProject = {};
